import { render, staticRenderFns } from "./RosterV2.vue?vue&type=template&id=a7805778&scoped=true&"
import script from "./RosterV2.vue?vue&type=script&lang=js&"
export * from "./RosterV2.vue?vue&type=script&lang=js&"
import style0 from "./RosterV2.vue?vue&type=style&index=0&id=a7805778&scoped=true&lang=css&"
import style1 from "./RosterV2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7805778",
  null
  
)

export default component.exports